import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHeadset,
  faThLarge,
  faTicketAlt,
  faTachometerAlt,
  faCog,
  faArrowLeft,
  faTimes
} from '@fortawesome/free-solid-svg-icons';

const SupportEngineSidebar = ({ activeTab, setActiveTab, isOpen = false, onClose }) => {

  const topMenuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: faThLarge, badge: null },
    { id: 'tickets', label: 'Lista de Tickets', icon: faTicketAlt, badge: null },
    { id: 'agents', label: 'Asesores', icon: faTachometerAlt, badge: null }
  ];

  const handleReturnToAdmin = () => {
    if (window.opener) {
      window.close();
    }
  };

  return (
    <aside className={`se-sidebar ${isOpen ? 'se-sidebar-open' : ''}`}>
      {/* Brand Logo Header */}
      <div className="d-flex align-items-center gap-2 mb-4 pb-1">
        <div className="se-logo-box">
          <FontAwesomeIcon icon={faHeadset} size="lg" />
        </div>
        <div>
          <h6 className="fw-bold mb-0 text-900" style={{ fontSize: '1.05rem', lineHeight: 1.2 }}>
            Support Engine
          </h6>
          <small className="text-muted" style={{ fontSize: '0.72rem' }}>
            Mesa de Ayuda
          </small>
        </div>

        {/* Botón cerrar visible solo en móvil */}
        <button
          type="button"
          className="btn btn-sm btn-light border-0 d-lg-none ms-auto rounded-circle d-flex align-items-center justify-content-center"
          onClick={onClose}
          style={{ width: '32px', height: '32px' }}
          aria-label="Cerrar menú"
        >
          <FontAwesomeIcon icon={faTimes} style={{ color: '#64748b' }} />
        </button>
      </div>

      {/* Navigation Items */}
      <nav className="d-flex flex-column gap-1 flex-grow-1">
        {topMenuItems.map(item => {
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              onClick={() => {
                setActiveTab(item.id);
                if (onClose) onClose();
              }}
              className={`se-nav-btn d-flex justify-content-between align-items-center ${isActive ? 'active' : ''}`}
            >
              <div className="d-flex align-items-center gap-2">
                <FontAwesomeIcon
                  icon={item.icon}
                  style={{
                    color: isActive ? '#4338ca' : '#64748b',
                    width: '18px'
                  }}
                />
                <span>{item.label}</span>
              </div>
              {item.badge && (
                <span
                  className="badge rounded-pill text-white"
                  style={{
                    backgroundColor: '#065f46',
                    fontSize: '0.7rem',
                    fontWeight: 700,
                    padding: '0.2rem 0.55rem'
                  }}
                >
                  {item.badge}
                </span>
              )}
            </button>
          );
        })}
      </nav>

      {/* Configuración */}
      <div className="mb-2">
        <button
          onClick={() => {
            setActiveTab('settings');
            if (onClose) onClose();
          }}
          className={`se-nav-btn ${activeTab === 'settings' ? 'active' : ''}`}
        >
          <FontAwesomeIcon
            icon={faCog}
            style={{
              color: activeTab === 'settings' ? '#4338ca' : '#64748b',
              width: '18px'
            }}
          />
          <span>Configuración</span>
        </button>
      </div>

      {/* Bottom Left Return Button */}
      <div className="pt-3 border-top">
        <Link
          to="/"
          onClick={() => {
            handleReturnToAdmin();
            if (onClose) onClose();
          }}
          className="se-nav-btn text-decoration-none d-flex align-items-center"
          title="Regresar a Akasia Admin Panel"
        >
          <FontAwesomeIcon
            icon={faArrowLeft}
            style={{ color: '#64748b', width: '18px' }}
          />
          <span style={{ fontSize: '0.85rem' }}>Volver al Admin</span>
        </Link>
      </div>
    </aside>
  );
};

export default SupportEngineSidebar;
